import { render, staticRenderFns } from "./SalesmansProjects.vue?vue&type=template&id=54c8090a&scoped=true&"
import script from "./SalesmansProjects.vue?vue&type=script&lang=js&"
export * from "./SalesmansProjects.vue?vue&type=script&lang=js&"
import style0 from "./SalesmansProjects.vue?vue&type=style&index=0&id=54c8090a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8090a",
  null
  
)

export default component.exports